import tracking from 'utils/tracking';
import { Workbox } from 'workbox-window';

export function register() {
  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  try {
    if ('serviceWorker' in navigator) {
      const wb = new Workbox(`${process.env.PUBLIC_URL}/sw.js`, { immediate: true });
      wb.register();
    }
  } catch (error) {
    tracking.warningV2('Service worker registration failed', {
      errorMessage: (error as Error)?.message
    });
  }
}

export function unregister() {
  try {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.ready.then(registration => {
        registration.unregister();
      });
    }
  } catch (error) {
    tracking.warningV2('Service worker unregistration failed', {
      errorMessage: (error as Error)?.message
    });
  }
}
